var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("layout-card", {
        staticClass: "dashboard__my-activities-card",
        attrs: {
          isCustomizable: _vm.settings.isCustomizable,
          type: _vm.settings.context,
          error: _vm.error,
          loading: _vm.isLoadingPage || _vm.loading
        },
        on: {
          "hide-card": function($event) {
            return _vm.$emit("hide-card", "my_activities")
          },
          "edit-card": _vm.handleConfigDialog,
          "refresh-card": _vm.refreshActivities
        },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function() {
              return [_vm._v(_vm._s(_vm.name))]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function() {
              return [
                _c("CompassLink", {
                  attrs: {
                    label: _vm.$t.__(
                      "dashboard.cards.MyActivitiesCard.actions.go_activity_page"
                    ),
                    target: "_blank",
                    link: _vm.linkActivitiesPage
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "content",
            fn: function() {
              return [
                !_vm.isLoadingPage || !_vm.loading
                  ? _c("ActivitiesListingTable", {
                      attrs: { columns: _vm.defaultColumns }
                    })
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }